// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2RqUY","footer":"ReportModalFilter_footer__3De9p"};